import { CollectionType } from '@/@types';
import { Scrollable } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import CollectionCard from '@/components/core/components/molecules/collection-card';
import * as styles from './carousel-collections.styles';

const CarouselCollections: UIComponent<{ collections: CollectionType[] }> = ({ collections }) => {
  return (
    <Scrollable iconOffset="70px" snap>
      <div className={styles.collections}>
        {collections.map((collection) => {
          return <CollectionCard size={150} vertical collection={collection} key={collection.id} />;
        })}
      </div>
    </Scrollable>
  );
};

export default CarouselCollections;
